/* * @Author: ligai  */
<template>
  <div class="search-btn-content">
    <div class="search-box">
      <div :class="['search-info']">
        <!-- 下拉 -->
        <div v-if="searchHasSelect.includes(getRouter) || platform === 'portal'" class="search-tab-content" @mouseleave="isShowSearchTab = false">
          <p class="current-search" @mouseenter="isShowSearchTab = true">
            <span class="current-search-angle">
              <span>
                {{currentActive === '0' ? pageText.goods : pageText.supplier}}
              </span>
              <i class="iconfont arrow">&#xe7d0;</i>
            </span>
          </p>
          <ul class="search-tab" v-show="isShowSearchTab">
            <li
              :key="tab.name"
              v-for="tab in searchTab"
              @click="tabSwitch(tab)"
              v-on:mouseover="changeActive(tab.name)"
              v-on:mouseout="removeActive(tab.name)"
              :class="{
                'category-background-color-hover': tab.name === activeName,
                'font-color-primary': tab.name === currentActive
              }">
              <span>{{tab.label}}</span>
            </li>
          </ul>
        </div>
        <!-- 搜索输入框 -->
        <input type="text" v-model.trim="name" :placeholder="tips"  @keyup.enter="search" :class="['search-input', 'search-border-color', {'search-in-supplier': currentActive === '1', 'padding-left': searchHasSelect.includes(getRouter) || platform === 'portal'}]" >
        <!-- 搜索按钮 -->
        <el-button v-if="currentSearchBtn === 'btn'" type="info" @click="searchProducts" size="mini" class="single-btn search-btn search-btn-color search-font-color search-border-color" data-spm-d='d1'>
          <span class="button-text">{{pageText.search}}</span>
        </el-button>
        <el-dropdown v-if="currentSearchBtn === 'groupBtn'" class="search-group-btn" @command="searchProducts">
          <el-button type="info" class="search-btn search-btn-color search-font-color search-border-color" @click="searchProducts('search-in-shop')">
            <span class="button-text">{{pageText.searchInShop}}<i class="iconfont icon-shangcheng-xialajiantou"></i></span>
          </el-button>
          <el-dropdown-menu class="search-btn-dropdown-menu" slot="dropdown">
            <el-dropdown-item command="">{{pageText.seekTotalStation}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <div v-if="showHistoryBox && !name" class="search-history">
          <ul>
            <li v-for="i in 10" :key="i" class="item font-color-primary_hover" @click="handleHistorySearch('测试')"> jisdfji <i class="iconfont icon-a-Group594 syue-right font-color-primary_hover" @click="removeHistory(i)"></i></li>
          </ul>
          <div class="clear-item">
            <span class="font-color-primary_hover">全部清空</span>
          </div>
        </div> -->
      </div>
    </div>
    <!-- 非商城采购 -->
    <div class="button-box">
      <template v-if="!($route.name === 'main' && !nonCatalogDisplay)">
        <template v-if="isFunctionDepartment && nonDirType === '2'">
          <router-link :to="{name: 'pr-manually-create-edit'}"  target="_self">
            <el-button size="mini" plain class="partition-color">{{pageText.createPurchaseRequisitions}}</el-button>
          </router-link>
        </template>
        <template v-if="getRouter !== 'req' && getRouter !== 'info' && getRouter !== 'supplier-shop' && isFunctionDepartment && nonDirType !== '2'">
          <!--非职能提示 -->
          <a :href="nonDirType === '3' ? nonDirLink : '/#/req'" v-if="!isGetCity || getRouter === 'cart'">
            <el-button size="mini" plain class="partition-color" data-spm-d='d2'>{{nonCatalogNameLabel}}</el-button>
          </a>
          <span class="offstore-tip" v-else>
            <el-popover
              placement="bottom"
              width="485"
              trigger="manual"
              popper-class="guide-popover"
              v-model="isGuide">
              <i class="triggle"></i>
              <p>{{pageText.noNeedProduct}}</p>
              <div class="guide-know-btn" @click="closeGuide">
                {{pageText.know}}
              </div>
              <template slot="reference">
                <a :href="nonDirType === '3' ? nonDirLink : '/#/req'">
                  <el-button size="mini" plain class="partition-color" data-spm-d='d2'>{{nonCatalogNameLabel}}</el-button>
                </a>
              </template>
            </el-popover>
          </span>
        </template>
      </template>
      <router-link :to="{name: 'cart'}" target="_self" class="shopping" v-if="getRouter !== 'cart'">
        <el-button size="mini" data-spm-d='d3'>
          <span class="iconfont shopping-icon">&#xe7c7;</span>
          <span  v-show="number" class="number">{{number > 99 ? '99+' : number}}</span>
          <!--购物车小球-->
          <span class="balls">
            <shop-cart-animation :distance="distance" :isFixed="isFixed"></shop-cart-animation>
          </span>
        </el-button>
      </router-link>
      <!-- <a v-if="!isAuth && isFixed" :href="login + '?url=' + encodeURIComponent(getUrl('/mall')) + '&isMall=true'">
        <el-button size="mini">{{pageText.login}}</el-button>
      </a> -->
    </div>
  </div>

</template>

<script>
import Api from '../api.js'
import response from 'fe-coms/utils/response'
import {ButtonGroup} from 'fe-coms'
import ShopCartAnimation from '../shop-cart-animation'
// import Api from './api.js'
// import response from 'fe-coms/utils/response'
import { getUrl } from '@/utils/url.js'
import { mapState, mapGetters } from 'vuex'
import i18n from '../i18n.js'
const pageText = window.fe.getPageText(i18n)
export default {
  name: 'header',
  components: {
    ButtonGroup,
    ShopCartAnimation
  },
  props: {
    supplierId: {
      type: String,
      default: ''
    },
    pageInfo: {
      type: Object,
      default: () => ({})
    },
    isFixed: {
      type: Boolean,
      default: false
    },
    isGetCity: {
      type: Boolean,
      default: true
    },
    platform: {
      type: String,
      default: ''
    }
  },
  data () {
    let isGuide = window.localStorage.getItem('userGuide') !== 'true'
    return {
      path: this.$route.path,
      pageText,
      name: this.$route.query.q || this.$route.query.materielCode || '',
      currentActive: this.$route.query.currentActive || '0',
      tips: pageText.enterKeyWord,
      isShowSearchTab: false,
      isGuide, // 是否显示引导
      distance: {
        top: 0,
        left: 0
      },
      mallSkuId: '',
      // 搜索按钮样式
      searchBtnStyle: {
        btn: ['main', 'list', 'compare-price', 'cart', 'req', 'scene-list', 'scene-detail', 'product-compare'],
        groupBtn: ['info', 'supplier-shop', 'store', 'store-shop', 'channel']
      },
      // 路由有左侧下拉
      searchHasSelect: ['main', 'list', 'channel', 'cart', 'req', 'compare-price', 'scene-list', 'scene-detail', 'product-compare'],
      // // 当前搜索按钮样式
      // currentSearchBtn: 'groupBtn'
      showHistoryBox: false,
      // 非商城按钮是否显示
      nonCatalogDisplay: false
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (n, o) {
        if (this.path === this.$route.path) {
          this.name = this.$route.query.q || this.$route.query.materielCode || ''
        }
      }
    },
    isAuth: {
      immediate: true,
      handler (value) {
        if (value) {
          this.getListByRuleKey()
        }
      }
    }
  },
  methods: {
    getUrl,
    // ----519------>616----
    // inputFocus () {
    //   this.showHistoryBox = true
    // },
    // inputBlur () {
    //   setTimeout(() => {
    //     this.showHistoryBox = false
    //   }, 200)
    // },
    // handleHistorySearch (keyword) {
    //   this.name = keyword
    //   this.search()
    // },
    // 关闭引导
    closeGuide () {
      this.isGuide = false
      window.localStorage.setItem('userGuide', true)
    },
    changeActive (tab) {
      this.activeName = tab
    },
    removeActive (tab) {
      this.activeName = ''
    },
    tabSwitch (tab) {
      this.currentActive = tab.name
      this.isShowSearchTab = false
      if (this.currentActive === '0') {
        this.tips = this.pageText.enterKeyWord
      } else if (this.currentActive === '1') {
        this.tips = this.pageText.enterSupplier
      }
      if (!this.name) return
      this.searchData()
    },
    search () {
      if (this.currentSearchBtn === 'btn') {
        this.searchProducts()
      } else {
        this.searchProducts('search-in-shop')
      }
    },
    // 搜索事件
    searchProducts (flag) {
      if (!this.name) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: this.tips
        })
        return
      }
      if (this.name.length > 60) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: this.variableReplace(this.pageText.enterNoMoreThan, {n: 60})
        })
        return
      }
      this.searchData(flag)
    },
    searchData (flag) {
      // this.currentSearch = this.currentActive
      // this.$emit('update:currentSearch', this.currentSearch)
      let pathName = window.location.pathname
      if (/^\/mall\/cart/.test(pathName)) {
        // 购物车和商城是两个单页应用的时候需要判断是从购物车跳转还是从商城跳转到搜索列表
        window.location.href = getUrl('/mall') + '/#list?q=' + encodeURIComponent(this.name) + '&supplierId=' + this.supplierId
      } else {
        if (flag === 'search-in-shop') {
          // 领用利旧跳搜本站
          if (this.supplierId < 0 || !this.supplierId || this.supplierId === 'null') {
            this.$router.replace('/store-shop?q=' + encodeURIComponent(this.name) + '&_t=' + new Date().getTime() + '&pageInfo=' + JSON.stringify({sysPurPageCode: this.pageInfo.sysPurPageCode, tempCode: this.pageInfo.tempCode}) + '&supplierId=' + this.supplierId)
          } else {
            this.$router.push('/supplier-shop?q=' + encodeURIComponent(this.name) + '&_t=' + new Date().getTime()  + '&supplierId=' + this.supplierId + '&mallSkuId=' + this.mallSkuId)
          }
        } else {
          this.$router.push('/list?q=' + encodeURIComponent(this.name) + '&_t=' + new Date().getTime() + '&currentActive=' + this.currentActive)
        }
      }
    },
    // 非商城在首页不显示配置
    async getListByRuleKey () {
      const api = Api.listByRuleKey
      const params = [
        'mall_home_page_not_show',
        'mall_purchase_name_config'
      ]
      const res = await response(this.$http(api.type, api.url, params))
      if (res.isOk) {
        const ruleObj = res.content || {}
        // 非商城按钮是否显示
        this.nonCatalogDisplay = ruleObj.mall_home_page_not_show?.value.indexOf('0') === -1
        // 非商城按钮名称
        const nonCatalogName = {
          'zh-CN': ruleObj.mall_purchase_name_config?.value,
          en: ruleObj.mall_purchase_name_config?.options?.mall_purchase_name_config[0]?.value
        }
        this.$store.commit('SET_NONCATALOG_NAME', nonCatalogName)
      }
    }
  },
  created () {
    this.mallSkuId = this.$route.params.mallSkuId || this.$route.query.mallSkuId || ''
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.shoppingNumber) {
        let rect = this.$refs.shoppingNumber.getBoundingClientRect()
        this.distance = {
          top: rect.top,
          left: rect.right - 50
        }
      }
    })
  },
  computed: {
    ...mapGetters(['nonCatalogNameLabel']),
    currentSearchBtn () {
      let pathName = this.$route.name
      if (this.platform === 'portal') {
        return 'btn'
      }
      for (let key in this.searchBtnStyle) {
        if (this.searchBtnStyle[key].includes(pathName)) {
          return key
        }
      }
    },
    getRouter () {
      return this.$route.name
    },
    // 使用对象展开运算符将 getter 混入 computed 对象中
    // 把 `this.cartCount` 映射为 `this.$store.getters.cartCount`
    ...mapState({
      number: state => state.cart.cartCount,
      isFunctionDepartment: state => state.user.isFunctionDepartment,
      nonDirType: state => state.user.nonDirType,
      nonDirLink: state => state.user.nonDirLink,
      isAuth: state => state.user.isAuth
    }),
    searchTab () {
      let searchItem = [
        {name: '0', label: this.pageText.goods}
      ]
      if (this.isAuth) {
        searchItem.push({name: '1', label: this.pageText.supplier})
      }
      return searchItem
    }
  }
}
</script>

<style scoped lang="scss">
  .main-search {
    .no-title-search .search-box .search-info {
      .search-input {
        width: 680px !important;
      }
    }
    .search-box {
      .search-info {
        .search-tab-content .current-search {
          height: 46px;
          line-height: 46px;
        }
        .search-input {
          width: 580px;
          height: 50px;
          line-height: 50px;
          padding: 0 24px 0px 24px;
        }
        .padding-left {
          padding-left: 114px;
        }
      }
      .search-btn {
        height: 50px;
      }
    }

    .button-box .el-button {
      height: 50px;
    }
    .shopping .el-button{
      width: 70px;;
    }
  }
  .right-search {
    .search-box {
      .search-info {
        .search-tab-content .current-search {
          width: 80px;
          height: 36px;
          line-height: 36px;
        }
        .search-input {
          width: 500px;
          height: 40px;
          line-height: 40px;
          padding: 0 24px 0px 24px;
        }
        .padding-left {
          padding-left: 94px
        }
        ::v-deep .el-button.search-btn {
          width: 80px;
          height: 40px;
        }
        .el-button--mini{
          font-size: 14px;
        }
      }
    }

    .button-box .el-button {
      height: 40px;
    }
    .shopping{
      .shopping-icon {
        font-size: 20px !important;
      }
    }
  }
  .search-box{
    display: inline-block;
    // margin: 0 auto;
    .search-info{
      display: inline-block;
      position: relative;
      .search-tab-content{
        position: absolute;
        top: 2px;
        left: 2px;
        cursor: pointer;
        z-index: 3;
        .current-search{
          color: #636E95;
          width: 100px;
          height: 36px;
          text-align: center;
          background: #FBFCFE;
          border-radius: 6px 0px 0px 6px;
          .current-search-angle{
            >span{
              // display: inline-block;
              // width: 65px;
              // text-align: right;
            }
          }
          .arrow {
            font-size: 8px;
            vertical-align: top;
            display: inline-block;
            transform: scale(0.68);
          }
          &:hover {
            .arrow {
              transform: scale(0.68) rotate(180deg);
            }
          }
        }
        .search-tab{
          background: #FFFFFF;
          box-shadow: 0 0 6px 0 rgba(0,0,0,0.16);
          border-radius: 4px;
          width: 104px;
          padding: 10px 0;
          margin-top: 2px;
          li{
            font-size: 14px;
            height: 28px;
            line-height: 28px;
            color: #666;
            cursor: pointer;
            padding: 0 12px;
            &:first-child{
              margin-bottom: 2px;
            }
          }
        }
      }
      .search-input{
        width: 400px;
        height: 40px;
        border-width: 2px;
        border-style: solid;
        box-sizing: border-box;
        border-radius: 8px;
        font-size: 16px;
        color: #242F57;
      }
      /* WebKit browsers */
      .search-input::-webkit-input-placeholder {
        color: #BFC7E0 !important;
        font-size: 14px !important;
        font-weight: 400;
      }
      /* Mozilla Firefox 4 to 18 */
      .search-input:-moz-placeholder {
        color: #BFC7E0 !important;
        font-size: 14px !important;
        opacity: 1 !important;
      }
      /* Mozilla Firefox 19+ */
      .search-input::-moz-placeholder {
        color: #BFC7E0 !important;
        font-size: 14px !important;
        opacity: 1 !important;
      }
      /* Internet Explorer 10+ */
      .search-input:-ms-input-placeholder {
        color: #BFC7E0 !important;
        font-size: 14px !important;
      }
      .single-btn {
        position: absolute;
        right: 0px;
        top: 0;
        // top: 2px;
        border-radius: 0px 6px 6px 0px;
        min-width: 100px;
        text-align: center;
        font-weight: 400;
      }
      .single-btn:hover{
        .button-text{
          opacity: 0.7;
        }
      }
      .search-group-btn:hover{
        .button-text{
          opacity: 0.7;
        }
      }
      .search-group-btn {
        position: absolute;
        right: 0px;
        top: 0px;
        // width: 100px;
        text-align: center;
        ::v-deep .el-button {
          text-align: center;
          width: 100px;
          padding: 0;
          border-radius: 0 6px 6px 0;
          font-weight: 400;
        }
      }
      .el-button--mini{
        font-size: 16px;
      }
      .button-text {
        display: inline-block;
        margin-left: 8px;
      }
      .icon-shangcheng-xialajiantou {
        font-size: 8px;
        display: inline-block;
        transform: scale(0.68);
        margin-left: 2px;
      }
      // .single-btn.el-button--mini{
      //   width: 100px;
      //   height: 36px;
      //   font-size: 16px;
      // }
      // .search-group-btn ::v-deep .el-button {
      //   height: inherit;
      //   width: 100px;
      //   border-radius: 0 6px 6px 0;
      // }
      // 搜索历史列表
      .search-history {
        position: absolute;
        left: 0;
        top: 56px;
        background: #fff;
        min-height: 300px;
        width: 100%;
        z-index: 100;
        box-shadow: 0px 0px 16px rgba(57, 121, 201, 0.2);
        border-radius: 8px;
        padding: 14px 0 20px 0;
        box-sizing: border-box;
        font-size: 12px;
        cursor: pointer;
        .item {
          padding: 0 10px 0 14px;
          line-height: 30px;
          color: #242F57;
          &:hover {
            background: #F3F4FA;
            i {
              display: block;
            }
          }
          i {
            color: #97A0C3;
            display: none;
          }
        }
        .clear-item {
          margin-top: 20px;
          text-align: right;
          color: #636E95;
          padding-right: 10px;
        }
      }
    }
  }
  .button-box{
    font-size: 0;
    display: inline-block;
    height: 100%;
    a {
      display: inline-block;
      vertical-align: middle;
      height: 100%;
    }
    .el-button {
      margin-left: 12px;
      border-radius: 8px;
      min-width: 58px;
      font-weight: 400;
    }
    button{
      background: #FFFFFF;
      border: 1px solid #E2E7F4;
      &:hover{
        opacity: 0.7;
        background: #fff;
      }
    }
    .el-button--mini{
      font-size: 14px;
    }
    .offstore-tip {
      position: relative;
    }
    .shopping{
      position: relative;
      .shopping-icon{
        color: #97a0c3;
        font-size: 24px;
      }
      .number{
        min-width: 14px;
        padding: 0 3px;
        height: 14px;
        display: inline-block;
        border-radius: 7px;
        background-color: #F73232;
        color: #fff;
        font-size: 11px;
        line-height: 14px;
        text-align: center;
        position: absolute;
        font-weight: 400;
        top: 4px;
        left: 50px;
      }
      .balls{
        float: right;
        margin-left: -20px;
        z-index: 99999;
        position: relative;
        left: 20px;
      }
    }
  }
</style>
<style lang="scss">
.search-btn-dropdown-menu {
  min-width: 100px;
  li{
    height: 28px;
    line-height: 28px;
    color: #242F57;
    text-align: center;
  }
}
// 有非商城采购提示浮层的样式
.guide-popover{
  width: 485px;
  min-height: 36px;
  padding: 6px 12px;
  line-height: 22px;
  box-sizing: border-box;
  top: 26px;
  right: 0;
  font-size: 12px;
  color: #666666;
  background: #FFF4E6;
  border: 1px solid #FFEACF;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.08);
  .triggle{
    position: absolute;
    top: -6px;
    right: 40px;
    display: inline-block;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #FFF4E6;
  }
  p{
    display: inline-block;
  }
  .guide-know-btn{
    float: right;
    width: 56px;
    text-align: center;
    line-height: 20px;
    font-size: 12px;
    color: #FFFFFF;
    background: #FFA535;
    border: 1px solid #F99519;
    border-radius: 2px;
    border-radius: 2px;
    cursor: pointer;
  }
}
</style>
